export default __webpack_public_path__ + "static/media/frame-open.b8fee37f.svg";